import { FC, useEffect } from 'react';

import { usePageTitle } from '../../../hooks/usePageTitle';
import { useAppBarHeading } from './useAppBarHeading';

interface Props {
  children: string;
}

export const AppBarHeading: FC<Props> = ({ children }) => {
  const { registerHeading } = useAppBarHeading();

  usePageTitle(children);

  useEffect(() => {
    const cleanup = registerHeading(children);
    return () => cleanup();
  }, [children, registerHeading]);

  return null;
};
